// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcaddd2b","488":"e75445ad","732":"ab4dd3f5","977":"ce2eb3e4"}[chunkId] + ".chunk.js";
};